
var stache = require('can/view/stache/stache');
module.exports = stache("<div class=\"c-live-video-player\">\r\n    <div id=\"playerHolder\" class=\"s-video\"></div>\r\n</div>");